module.exports = __webpack_public_path__ + "static/media/11.fc5b6c81.jpg";